import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import ProductActions from '@Actions/productActions';
import defaultImage from '@Images/icons/imageDefault.png';
import H3Image from '@Uilib/h3Image';
import { QUANTITY } from '@Apis/constants';
import './style.scss';
/**
 *
 */
class OtherDepartmentsStock extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   *
   */
  componentDidMount() {
    const {
      getOrgProductById, user, selectedProductSkuId, tenantId,
    } = this.props;
    getOrgProductById(user?.tenant_info?.org_id, tenantId, selectedProductSkuId);
  }

  /**
   * @param record
   */
  getStatusBackgroundColor(record) {
    if (record?.available_qty >= record?.threshold_qty && (record?.threshold_qty !== 0)) {
      return 'rgba(110,220,36,0.1)';
    }
    if (record?.available_qty > record?.threshold_qty && (record?.threshold_qty === 0)) {
      return 'rgba(110,220,36,0.1)';
    }
    if ((record?.available_qty < record?.threshold_qty) && record?.available_qty > 0) {
      return '#2d7df71a';
    }
    return 'rgba(247,45,45,0.05)';
  }

  /**
   *
   * @param record
   * @return {{className: string, label: string}}
   */
  getStockStatus(record) {
    if (record?.available_qty >= record?.threshold_qty && (record?.threshold_qty !== 0)) {
      return { label: 'Well Stocked', className: 'product_stock-status__stocked' };
    }
    if (record?.available_qty > record?.threshold_qty && (record?.threshold_qty === 0)) {
      return { label: 'Well Stocked', className: 'product_stock-status__stocked' };
    }
    if ((record?.available_qty < record?.threshold_qty) && record?.available_qty > 0) {
      return { label: 'Running Low', className: 'product_stock-status__low' };
    }
    return { label: 'Out of Stock', className: 'product_stock-status__ooo' };
  }

  /**
   *
   * @return
   */
  render() {
    const {
      selectedOrgProduct, user, getOrgProductByIdLoading, tenantId, uomType
    } = this.props;
    const tenantProduct = selectedOrgProduct?.tenant_products?.filter((item) => item?.tenant_id === tenantId)?.[0];
    return (
      <div className="tenant-inventory__slider">
        <div className="tenant-inventory__slider__body">
          {getOrgProductByIdLoading
            ? (
              <div className="loader__container">
                <div className="loading-row0">
                  <div className="loading-row0-left loadingBlock" />
                  <div className="loading-row0-right loadingBlock" />
                </div>
                <div className="loading-row1 loadingBlock" />
                <div className="loading-row2 loadingBlock" />
                <div className="loading-row3 loadingBlock" />
              </div>
            )
            : (
              <div className="tenant-inv__slider__vendor" style={{ backgroundColor: this.getStatusBackgroundColor(tenantProduct) }}>
                <div className="" style={{ width: '100%' }}>
                  <div className="tenant-inventory-slider__stock-status-wrapper" style={{ display: 'flex' }}>
                    <div className="tenant-inventory-slider__vendor-name">
                      {tenantProduct?.tenant_name}
                    </div>
                    <H3Text text={this.getStockStatus(tenantProduct).label} className={`${this.getStockStatus(tenantProduct)?.className} tenant-inventory-slider__stock-status`} />
                  </div>
                  <div className="tenant-inventory__product-info">
                    {selectedOrgProduct?.assets?.[0]?.url
                      ? <H3Image src={selectedOrgProduct?.assets?.[0]?.url} className="tenant-inventory__product-img" />
                      : <H3Image src={defaultImage} className="default-tenant-inventory__product-img" />}
                    <div className="tenant-inventory__product-name">{selectedOrgProduct?.product_sku_name}</div>
                  </div>
                  {tenantProduct?.available_stock?.length && uomType !== 'secondary' && (
                    <div className="tenant-inventory-slider__dept-data">
                      {
                        tenantProduct?.available_stock?.map((dept) => (
                          <div key={dept.tenant_department_id} className="tenant-inventory-slider__dept-row">
                            <H3Text text={dept?.department_name} className="tenant-inventory-slider__dept-name" />
                            <H3Text
                              text={`${QUANTITY(Helpers.getValueTotalInObject(dept?.batches, 'available_qty'))} ${selectedOrgProduct?.uqc?.toProperCase()}`}
                              className="tenant-inventory-slider__dept-qty"
                            />
                          </div>
                        ))
                      }
                    </div>
                  )}
                  <br />
                  {uomType !== 'secondary' && <div className="tenant-inventory-total">{`Total Available Stock: ${QUANTITY(tenantProduct?.available_qty)} ${selectedOrgProduct?.uqc?.toProperCase()}`}</div>}
                  {tenantProduct?.secondary_available_stock?.length && uomType === 'secondary' && (
                    <div className="tenant-inventory-slider__dept-data">
                      {
                        tenantProduct?.secondary_available_stock?.map((dept) => (
                          <div key={dept.tenant_department_id} className="tenant-inventory-slider__dept-row">
                            <H3Text text={dept?.department_name} className="tenant-inventory-slider__dept-name" />
                            <H3Text
                              text={`${QUANTITY(dept?.secondary_available_qty_department_wise)} ${selectedOrgProduct?.secondary_uom_info?.uqc?.toProperCase()}`}
                              className="tenant-inventory-slider__dept-qty"
                            />
                          </div>
                        ))
                      }
                    </div>
                  )}
                  <br />
                  {uomType === 'secondary' && <div className="tenant-inventory-total">{`Total Available Stock: ${QUANTITY(tenantProduct?.secondary_available_qty)} ${selectedOrgProduct?.secondary_uom_info?.uqc?.toProperCase()}`}</div>}
                  <div className="inventory-slider__vendor-price-wrapper" />
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({
  UserReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  selectedOrgProduct: ProductReducers.selectedOrgProduct,
  getOrgProductByIdLoading: ProductReducers.getOrgProductByIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getOrgProductById: (orgId, tenantId, productSkuId, callback) => dispatch(ProductActions.getOrgProductById(orgId, tenantId, productSkuId, callback)),
});

OtherDepartmentsStock.propTypes = {
  history: PropTypes.func,
  getOrgProductById: PropTypes.func,
  getOrgProductByIdLoading: PropTypes.bool,
  user: PropTypes.any,
  selectedProductSkuId: PropTypes.any,
  tenantId: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OtherDepartmentsStock));
